const Home = () => import('Views/home/home');

export default[
  { path: '/', component: Home },
  { path: '/home', component: Home },
];



// WEBPACK FOOTER //
// ./src/router/home.js